import { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";
import { LANGS, useLang } from "@/i18n";

export default function LangMenu() {
  const { lang, setLang } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        data-testid="lang-toggle"
        aria-label="Lingua"
        className="rounded-full border border-current/40 opacity-90 hover:opacity-100 text-[10px] font-bold tracking-[0.1em] px-3 py-1.5 transition-opacity flex items-center gap-1"
      >
        {lang.toUpperCase()} <ChevronDown size={11} className={`transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div
          data-testid="lang-menu"
          className="absolute right-0 top-full mt-2 bg-[#1A1B18] text-white rounded-xl overflow-hidden shadow-xl border border-white/10 min-w-[140px] z-50"
        >
          {LANGS.map((l) => (
            <button
              key={l.id}
              onClick={() => {
                setLang(l.id);
                setOpen(false);
              }}
              data-testid={`lang-option-${l.id}`}
              className={`w-full text-left px-4 py-2.5 text-xs tracking-[0.1em] flex items-center justify-between gap-3 transition-colors ${
                lang === l.id ? "bg-[#A86946]" : "hover:bg-white/10"
              }`}
            >
              <span className="font-bold">{l.label}</span>
              <span className="text-white/50 text-[10px]">{l.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
